import { Product } from "@/types/entities";
import { Nutrition } from "@/types/generated/product";
import { create } from "zustand";

export type ModalType = "brands" | "qr-code" | "cards" | "links";

interface InitialState {
    open: boolean;
    loading: boolean;
    modalType: ModalType;
    modalTitle: string;
    product?: {
        pid: string;
        typeName: Product["typeName"];
        eid: Product["eid"];
        longTitle: string;
        shortTitle: string;
        nutrition?: Nutrition;
    };
}

interface Actions {
    onOpen(
        modalType: InitialState["modalType"],
        modalTitle: string,
        product?: InitialState["product"],
    ): void;
    onClose(): void;
    setLoading(loading: boolean): void;
}

const initialState: InitialState = {
    open: false,
    loading: false,
    modalType: "qr-code",
    modalTitle: "",
};

export const useModal = create<InitialState & Actions>(set => ({
    ...initialState,
    onOpen: (modalType, modalTitle, product) => {
        set({ open: true, modalType, modalTitle, ...(product && { product }) });
    },
    onClose: () => set(initialState),
    setLoading: loading => set({ loading }),
}));
